<template>
    <div>
      <div class="action-buttons ">
        <div class="left-buttons mar-rt-10">
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group" v-if="groupedLocations">
              <label>{{ $t('gestiune.locatie') }}</label>
              <select class="form-control" v-model="selectedLocation" :disabled="loading">
                <optgroup
                  v-for="group in groupedLocations"
                  :key="group.vat"
                  :label="`VAT: ${group.vat}`"
                >
                  <option
                    v-for="loc in group.locations"
                    :key="loc.id"
                    :value="loc"
                  >
                    {{ loc.name }}
                  </option>
                </optgroup>
              </select>
            </div>
          </div>
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>{{ $t('gestiune.gestiune') }}</label>
              <el-select
                  v-model="selectedGestiune"
                  placeholder="Selectează gestiunea"
                  :disabled="loading"
                >
                <el-option
                  v-for="gestiune in filteredGestiuni"
                  :key="gestiune.id"
                  :label="gestiune.name"
                  :value="gestiune.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>Date și oră</label>
              <el-date-picker
                type="datetimerange"
                v-model="searchDate"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                class="w-100"
                :picker-options="pickerOptions"
                :disabled="loading"
                placeholder="Selectează intervalul"
              ></el-date-picker>
            </div>
          </div>
         </div>
         <div class="right-buttons" style="display: flex; align-items: center; justify-content: flex-end;">
          <div class="search-button-reports">
            <button
                :title="$t('reports.search')"
                class="btn add mar-rt-10"
                @click="triggerFilter"
            >
                <i class="ti-search"></i>
                <span>{{ $t('general.search') }}</span>
            </button>
          </div>
          <div class="search-button-reports pull-left">
            <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="fetchBalanceReport('xls')">{{$t('general.download_xls') }} <img src="/static/img/export_xls.png"></div>
          </div>
         </div>
      </div>
      <div class="card mar-to-15 tableInvoice">
        <div class="card-content">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="data-table-wrapper">
            <div v-if="tableData && tableData.length" class="consumption-total-header">
              <strong>TOTAL:</strong>
              {{ totalItems }} produse
            </div>
            <table class="main-table">
              <thead>
                <!-- Nivel 1: Grup mare -->
                <tr>
                  <th rowspan="3" class="align-left">Nr.</th>
                  <th rowspan="3" class="align-left product-column">Produs</th>
                  <th rowspan="3" class="align-center">UM</th>

                  <th colspan="2" class="align-center">STOC INITIAL</th>

                  <th colspan="6" class="align-center">INTRARI</th>
                  <th colspan="16" class="align-center">IESIRI</th>

                  <th colspan="2" class="align-center">STOC FINAL</th>
                </tr>

                <!-- Nivel 2: Subgrupuri -->
                <tr class="subheaders">
                  <!-- STIC INITIAL nu are subgrup -->
                  <th colspan="2"></th>

                  <!-- INTRARI -->
                  <th colspan="2" class="align-center">NIR</th>
                  <th colspan="2" class="align-center">Transfer</th>
                  <th colspan="2" class="align-center">Producție</th>

                  <!-- IESIRI -->
                  <th colspan="2" class="align-center">NIR</th>
                  <th colspan="2" class="align-center">Vânzare</th>
                  <th colspan="2" class="align-center">Bon consum</th>
                  <th colspan="2" class="align-center">Transfer</th>
                  <th colspan="2" class="align-center">Producție</th>
                  <th colspan="2" class="align-center">Pierdere</th>
                  <th colspan="2" class="align-center">Aviz</th>
                  <th colspan="2" class="align-center">Diff. Inventar</th>

                  <!-- STOC FINAL nu are subgrup -->
                  <th colspan="2"></th>
                </tr>

                <!-- Nivel 3: Cant / Val -->
                <tr class="subheaders">
                  <!-- STOC INITIAL -->
                  <th class="align-center numeric">Cant</th>
                  <th class="align-center numeric">Val</th>

                  <!-- INTRARI -->
                  <th class="align-center numeric">Cant</th>
                  <th class="align-center numeric">Val</th>

                  <th class="align-center numeric">Cant</th>
                  <th class="align-center numeric">Val</th>

                  <th class="align-center numeric">Cant</th>
                  <th class="align-center numeric">Val</th>

                  <!-- IESIRI -->
                  <th class="align-center numeric">Cant</th>
                  <th class="align-center numeric">Val</th>

                  <th class="align-center numeric">Cant</th>
                  <th class="align-center numeric">Val</th>

                  <th class="align-center numeric">Cant</th>
                  <th class="align-center numeric">Val</th>

                  <th class="align-center numeric">Cant</th>
                  <th class="align-center numeric">Val</th>

                  <th class="align-center numeric">Cant</th>
                  <th class="align-center numeric">Val</th>

                  <th class="align-center numeric">Cant</th>
                  <th class="align-center numeric">Val</th>

                  <th class="align-center numeric">Cant</th>
                  <th class="align-center numeric">Val</th>

                  <th class="align-center numeric">Cant</th>
                  <th class="align-center numeric">Val</th>

                  <!-- STOC FINAL -->
                  <th class="align-center numeric">Cant</th>
                  <th class="align-center numeric">Val</th>
                </tr>
              </thead>

              <tbody v-if="tableData && tableData.length">
                <tr v-for="row in tableData" :key="row.nr">
                  <td>{{ row.nr }}</td>
                  <td class="product-column">{{ row.product_name }}</td>
                  <td>{{ row.unit }}</td>

                  <!-- STOC INITIAL -->
                  <td class="numeric">{{ formatNumber(row.stock_initial_qty) }}</td>
                  <td class="numeric">{{ formatNumber(row.stock_initial_val) }}</td>

                  <!-- INTRARI -->
                  <td class="numeric">{{ formatIfNotZero(row.entries_nir_qty) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.entries_nir_val) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.entries_transfer_qty) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.entries_transfer_val) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.entries_productie_qty) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.entries_productie_val) }}</td>

                  <!-- IESIRI -->
                  <td class="numeric">{{ formatIfNotZero(row.exits_nir_qty) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.exits_nir_val) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.exits_vanzare_qty) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.exits_vanzare_val) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.exits_bon_consum_qty) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.exits_bon_consum_val) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.exits_transfer_qty) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.exits_transfer_val) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.exits_productie_qty) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.exits_productie_val) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.exits_casare_qty) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.exits_casare_val) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.exits_aviz_qty) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.exits_aviz_val) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.exits_inventar_qty) }}</td>
                  <td class="numeric">{{ formatIfNotZero(row.exits_inventar_val) }}</td>
                  <!-- STOC FINAL -->
                  <td class="numeric">{{ formatNumber(row.stock_final_qty) }}</td>
                  <td class="numeric">{{ formatNumber(row.stock_final_val) }}</td>
                </tr>
              </tbody>

              <tbody v-else>
                <tr>
                  <td :colspan="29">
                    <div style="display: flex; justify-content: center; align-items: center; width: 100%; padding: 20px; color: #909399;">
                      {{ $t('gestiune.noData') }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import swal from 'sweetalert2'

export default {
  components: {
    GeneralTopBar
  },
  data () {
    const end = new Date()
    const start = new Date()
    start.setDate(end.getDate() - 29)
    start.setHours(0, 0, 0, 0)
    end.setHours(23, 59, 59, 999)

    return {
      loading: false,
      tableData: [],
      totalItems: 0,
      selectedGestiune: null,
      selectedLocation: null,
      searchDate: [start, end],
      selectedProduct: {},
      pickerOptions: {
        shortcuts: [
          {
            text: 'Astăzi',
            onClick (picker) {
              const start = new Date()
              start.setHours(0, 0, 0, 0)
              const end = new Date()
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Ieri',
            onClick (picker) {
              const start = new Date()
              start.setDate(start.getDate() - 1)
              start.setHours(0, 0, 0, 0)
              const end = new Date()
              end.setDate(end.getDate() - 1)
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Ultimele 7 zile',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setDate(end.getDate() - 6)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Ultimele 30 de zile',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setDate(end.getDate() - 29)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Luna curentă',
            onClick (picker) {
              const start = new Date()
              start.setDate(1)
              start.setHours(0, 0, 0, 0)
              const end = new Date()
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Luna trecută',
            onClick (picker) {
              const date = new Date()
              const start = new Date(date.getFullYear(), date.getMonth() - 1, 1)
              const end = new Date(date.getFullYear(), date.getMonth(), 0)
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Anul curent',
            onClick (picker) {
              const start = new Date(new Date().getFullYear(), 0, 1)
              const end = new Date()
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Anul trecut',
            onClick (picker) {
              const year = new Date().getFullYear() - 1
              const start = new Date(year, 0, 1)
              const end = new Date(year, 11, 31)
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick ({ maxDate, minDate }) {
          if (minDate && !maxDate) {
            minDate.setHours(0, 0, 0, 0)
          }
          if (maxDate) {
            maxDate.setHours(23, 59, 59, 999)
          }
        }
      }
    }
  },
  props: {
    gestiuneOptions: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredGestiuni () {
      if (!this.selectedLocation) return []
      const result = this.gestiuneOptions.filter(
        (g) => g.externalLocationId === this.selectedLocation.true_id
      )
      return result
    }
  },
  watch: {
    selectedLocation (newLocation) {
      this.resetTable()

      this.selectedGestiune = null
      this.tableData = []
      if (this.filteredGestiuni && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id
      }
      this.selectedVatNumber = newLocation.inv_fiscal_code
    }
  },
  created () {
    this.companyID = this.$session.get('selectedCompany')
  },
  mounted () {
    this.firstLoad()
  },
  methods: {
    formatNumber (value) {
      if (value === null || value === undefined) return ''
      const num = Number(value)
      if (isNaN(num)) return ''
      return num.toFixed(2)
    },
    formatIfNotZero (value) {
      if (!value || Number(value) === 0) return ''
      return Number(value).toFixed(2)
    },
    firstLoad () {
      if (this.groupedLocations && this.groupedLocations.length) {
        this.selectedLocation = this.groupedLocations[0].locations[0]
      }
    },
    triggerFilter () {
      if (!this.selectedGestiune) {
        return
      }
      if (!this.selectedLocation) {
        return
      }
      if (!this.searchDate || this.searchDate.length !== 2) {
        return
      }

      this.resetTable()
      this.fetchBalanceReport()
    },
    async fetchBalanceReport (exportFormat = null) {
      // Validare
      if (!this.selectedGestiune || !this.selectedLocation || !this.searchDate) return

      this.loading = true

      swal({
        type: 'info',
        title: 'Se generează raportul de balanta centralizata',
        text: 'Vă rugăm așteptați...',
        allowOutsideClick: false,
        didOpen: () => swal.showLoading()
      })

      try {
        const [startDate, endDate] = this.searchDate
        const externalCompanyId = this.$session.get('selectedCompany')

        const params = new URLSearchParams({
          gestiune: this.selectedGestiune,
          startDate: new Date(startDate).toISOString(),
          endDate: new Date(endDate).toISOString(),
          externalCompanyId,
          externalLocationId: this.selectedLocation.true_id,
          vatNumber: this.selectedLocation.inv_fiscal_code
        })

        if (exportFormat) {
          params.append('export', exportFormat.toUpperCase())
        }

        const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/reports/centralized-balance?${params.toString()}`

        // Export XLS
        if (exportFormat) {
          window.location.href = url
          setTimeout(() => swal.close(), 800)
          return
        }

        const response = await fetch(url)
        if (!response.ok) throw new Error(`HTTP ${response.status}`)

        const data = await response.json()

        // Transformare date pentru tabel
        this.tableData = data.items.map((item, index) => ({
          nr: index + 1,
          product_name: item.product_name,
          unit: item.unit,
          stock_initial_qty: item.stock_initial.quantity,
          stock_initial_val: item.stock_initial.value,
          entries_nir_qty: item.entries.nir.quantity,
          entries_nir_val: item.entries.nir.value,
          entries_transfer_qty: item.entries.transfer.quantity,
          entries_transfer_val: item.entries.transfer.value,
          entries_productie_qty: item.entries.productie.quantity,
          entries_productie_val: item.entries.productie.value,
          exits_nir_qty: item.exits.nir.quantity,
          exits_nir_val: item.exits.nir.value,
          exits_vanzare_qty: item.exits.vanzare.quantity,
          exits_vanzare_val: item.exits.vanzare.value,
          exits_bon_consum_qty: item.exits.bon_consum.quantity,
          exits_bon_consum_val: item.exits.bon_consum.value,
          exits_transfer_qty: item.exits.transfer.quantity,
          exits_transfer_val: item.exits.transfer.value,
          exits_productie_qty: item.exits.productie.quantity,
          exits_productie_val: item.exits.productie.value,
          exits_casare_qty: item.exits.casare.quantity,
          exits_casare_val: item.exits.casare.value,
          exits_aviz_qty: item.exits.aviz.quantity,
          exits_aviz_val: item.exits.aviz.value,
          exits_inventar_qty: item.exits.inventar.quantity,
          exits_inventar_val: item.exits.inventar.value,
          stock_final_qty: item.stock_final.quantity,
          stock_final_val: item.stock_final.value
        }))

        this.totalItems = data.totalItems || 0
      } catch (err) {
        console.error('Eroare raport balanta centralizata:', err)
        this.tableData = []
        swal({
          title: 'Eroare',
          text: 'Nu s-a putut genera raportul de balanta centralizata.',
          icon: 'error'
        })
      } finally {
        this.loading = false
        swal.close()
      }
    },
    resetTable () {
      this.tableData = []
    }
  }
}
</script>

<style scoped>
.main-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: fixed;
}

tbody td {
  font-size: 12px;
  font-weight: 400 !important;
  text-align: center !important;
}

/* Coloana produs mai lată și text pe 2+ rânduri */
.product-column {
  width: 100px; /* ajustează după nevoie */
  white-space: normal; /* permite wrap text */
  word-break: break-word; /* rupe cuvintele prea lungi */
  line-height: 1.4em; /* crește înălțimea rândului */
  text-align: left; /* text la stânga */
  padding: 8px; /* mai mult spațiu pentru lizibilitate */
}

.main-table th,
.main-table td {
  padding: 6px;
  text-align: center;
  vertical-align: middle;
  background-color: #fff;
  font-weight: 500;
  overflow: visible;
  white-space: normal;
  text-overflow: clip;
  word-break: break-word;
  border: 1px solid #25396f26;
}
td.numeric {
  word-break: unset !important;
  text-align: left !important;
}
.main-table td {
  border: 1px solid #25396f26;
}
.subheaders th:first-child {
  border-radius: 0px !important;
}
.consumption-total-header {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
}
.subheaders th:last-child {
  border-radius: 0px !important;
}

.main-table thead th {
  position: sticky;
  top: 60px;
  background-color: #E4E8F9;
  z-index: 2;
  border-radius: 0px;
  font-size: 12px;
}

/* primul rând de subheaders (nivel 2) */
.main-table thead tr.subheaders:nth-child(2) th {
  top: 88px;
  background-color: #E4E8F9;
  z-index: 2;
  font-size: 12px;
}

/* al doilea rând de subheaders (nivel 3) */
.main-table thead tr.subheaders:nth-child(3) th {
  top: 117px; /* ajustați în funcție de înălțimea primului rând */
  background-color: #D9E1F2;
  z-index: 1;
  font-size: 10px;
}
.align-left {
  text-align: left;
}

@media (max-width: 768px) {
  .main-table {
    font-size: 13px;
  }
  .main-table th,
  .main-table td {
    padding: 4px;
  }
}
.search-button-reports button.add{
  background-color: #20BFAB !important;
  border: 1px solid #20BFAB !important;
}
.main-table th,
.main-table td {
  padding: 6px 8px;
}
thead tr:nth-child(2) th{
  border-radius: 0px !important;
}
tbody td{
  background-color: #fff !important;
}
.row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
@media (max-width: 768px) {
  .main-table {
    font-size: 13px;
  }

  .main-table th,
  .main-table td {
    padding: 8px 6px;
  }
}
.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Aliniază butoanele pe axa verticală */
  margin-bottom: 15px;
}
.form-group {
  display: grid;
}
.left-buttons {
  display: flex;
}
.disabled {
  pointer-events: none;
  opacity: 0.5;
}
.left-buttons button{
  display: flex;
  align-items: center;
  padding-top: 10px;
}

.left-buttons el-button {
  margin-right: 10px; /* Spațiere între butoane */
}
.right-button {
  margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Reports/BalanceReport.vue